import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./inventory.css";

export default function InventoryEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({
    name: "",
    description: "",
    category: "",
    quantity: "",
    purchase_price: "",
    vendor: "",
    purchase_date: "",
  });

  // ================= LOAD DATA =================
  useEffect(() => {
    loadCategories();
    loadItem();
  }, []);

  const loadCategories = async () => {
    const res = await API.get("/school-admin/inventory/categories/", {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setCategories(res.data.categories || []);
  };

  const loadItem = async () => {
    const res = await API.get(
      `/school-admin/inventory/items/${id}/`,
      { headers: { "X-SCHOOL-ID": school.school.id } }
    );
    setForm(res.data);
  };

  // ================= SAVE =================
  const save = async () => {
    try {
      await API.put(
        `/school-admin/inventory/items/${id}/`,
        form,
        { headers: { "X-SCHOOL-ID": school.school.id } }
      );

      alert("Item updated successfully");
      navigate("/school-admin/inventory");
    } catch (err) {
      alert("Update failed");
    }
  };

  return (
    <div className="inventory-page">
      <h2 className="inventory-title">Edit Inventory Item</h2>

      <div className="inventory-form">

        <div className="form-group">
          <label>Item Name</label>
          <input
            value={form.name}
            onChange={e => setForm({ ...form, name: e.target.value })}
          />
        </div>

        <div className="form-group">
          <label>Category</label>
          <select
            value={form.category}
            onChange={e => setForm({ ...form, category: e.target.value })}
          >
            <option value="">Select Category</option>
            {categories.map(c => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Description</label>
          <textarea
            value={form.description}
            onChange={e => setForm({ ...form, description: e.target.value })}
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Quantity</label>
            <input
              type="number"
              value={form.quantity}
              onChange={e => setForm({ ...form, quantity: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Purchase Price (₹)</label>
            <input
              type="number"
              value={form.purchase_price}
              onChange={e =>
                setForm({ ...form, purchase_price: e.target.value })
              }
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Vendor</label>
            <input
              value={form.vendor}
              onChange={e => setForm({ ...form, vendor: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label>Purchase Date</label>
            <input
              type="date"
              value={form.purchase_date}
              onChange={e =>
                setForm({ ...form, purchase_date: e.target.value })
              }
            />
          </div>
        </div>

        <button className="btn-submit" onClick={save}>
          Save Changes
        </button>
      </div>
    </div>
  );
}